export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض"])}
        }
      },
      "ar-EG": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض"])}
        }
      },
      "ar-SA": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض"])}
        }
      },
      "el-GR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση"])}
        }
      },
      "el-CY": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση!"])}
        }
      },
      "de-DE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen"])}
        }
      },
      "de-AT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen"])}
        }
      },
      "de-CH": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen"])}
        }
      },
      "en-US": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display"])}
        }
      },
      "en-GB": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display"])}
        }
      },
      "it-IT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessun dato da visualizzare"])}
        }
      },
      "fr-FR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher"])}
        }
      },
      "es-ES": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡No hay información para mostrar"])}
        }
      },
      "pl-PL": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak danych do wyświetlenia"])}
        }
      },
      "nl-NL": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen gegevens om weer te geven"])}
        }
      },
      "bg-BG": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма данни за показване"])}
        }
      },
      "bs-BA": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz"])}
        }
      },
      "da-DK": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data at vise"])}
        }
      },
      "et-EE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole andmeid, mida kuvada"])}
        }
      },
      "fi-FI": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei näytettäviä tietoja"])}
        }
      },
      "he-IL": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין נתונים להצגה"])}
        }
      },
      "ga-IE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan aon sonraí le taispeáint"])}
        }
      },
      "ja-JP": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["表示するデータがありません"])}
        }
      },
      "hr-HR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz"])}
        }
      },
      "lv-LV": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav datu, ko parādīt"])}
        }
      },
      "lt-LT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra rodomų duomenų"])}
        }
      },
      "pt-PT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sem dados para exibir"])}
        }
      },
      "ro-RO": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu sunt date de afișat"])}
        }
      },
      "ru-RU": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет данных для отображения"])}
        }
      },
      "sv-SE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data att visa"])}
        }
      },
      "sk-SK": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žiadne údaje na zobrazenie"])}
        }
      },
      "cs-CZ": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádná data k zobrazení"])}
        }
      },
      "hu-HU": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nincs megjeleníthető adat"])}
        }
      },
      "fr-BE": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "fr-LU": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "mt-MT": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda dejta li trid turi"])}
        }
      },
      "sl-SI": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni podatkov za prikaz"])}
        }
      },
      "tr-TR": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok"])}
        }
      },
      "tr-CY": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok!"])}
        }
      },
      "uk-UA": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Немає даних для відображення"])}
        }
      },
      "zh-CN": {
        "nothingToShow": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有数据显示"])}
        }
      }
    }
  })
}
